import React, { useContext } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  TextareaAutosize,
  Typography,
} from "@material-ui/core";
import { Formik, useFormikContext } from "formik";
import { NotificationManager } from "react-notifications";

import { usePublish } from "../../../../../../../../hooks/publisher-subscriber"
import PageDomain from "../../../../domain";
import { UserListContext } from "../../../../../../../../context/follow-up-widgets";
import PostServiceApi from "../../../../../../../../services/post-service";

const AddFollowUpCommentView = () => {
  const { setResults, currentSideView } = useContext(UserListContext);
  const { values: filters, setFieldValue: setFilterValue } = useFormikContext(
    {}
  );
  const publish = usePublish();

  const onSubmitForm = async (values, actions) => {
    publish("follow-up");

    try {
      const data = {
        memberId: currentSideView.advertisement?.memberId,
        comment: values.comment,
      };
      const response = await PostServiceApi.addFollowUpComment({ data });
      if (!response.success) {
        NotificationManager.error("Failed to add the follow-up comment.");
        return;
      }
      actions.resetForm();

      NotificationManager.success("Comment Added");
      PageDomain.setSearchResults({
        values: filters,
        setFieldValue: setFilterValue,
        setResults,
      });
      publish("closeSideView");
    } catch (error) {
      console.log(error);
      NotificationManager.error("Failed to add the follow-up comment.");
    } finally {
      actions.setSubmitting(true);
    }
  };

  return (
    <Grid container direction="column" className="add-follow-up-comment-view">
      <Formik initialValues={{}} onSubmit={onSubmitForm}>
        {({ handleChange, values, submitForm, isSubmitting }) => (
          <Grid container direction="column" className="gap-y-16">
            <Typography variant="body2">Add a follow up comment</Typography>
            <TextareaAutosize
              name="comment"
              minRows={3}
              placeholder="comment..."
              value={values.comment ?? ""}
              onChange={handleChange}
            />
            <Button
              variant="contained"
              type="submit"
              onClick={submitForm}
              disabled={!values?.comment || isSubmitting}
              {...(isSubmitting && {
                endIcon: <CircularProgress size={15} className="color-white" />,
              })}
            >
              Add Comment
            </Button>
          </Grid>
        )}
      </Formik>
    </Grid>
  );
};

export default AddFollowUpCommentView;
